import { render } from "./IndexVille.vue?vue&type=template&id=69699f76"
import script from "./IndexVille.vue?vue&type=script&lang=js"
export * from "./IndexVille.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__